import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/api-authorization/user/user.service';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.css']
})
export class AuthenticationComponent implements OnInit {

  constructor(private userService: UserService) { }

  ngOnInit() {
  }
}
